// extracted by mini-css-extract-plugin
module.exports = {"table-wrapper":"ConfirmationLabTable_table-wrapper__1kbxt"};